import React, { useEffect, useState } from 'react'
import { loadUserTalentsCount } from '../utils/Network';

export default function TalentBadge({ talent_id , count }) {




    // const [count, setCount] = useState(null);

    useEffect(() => {
        // loadUserTalentsCount(talent_id).then(count => {
        //     if (count > 0)
        //         setCount(count)
        // })
    }, []);



    return (
        <>

            <span className="pull-right-container">
                {count && count > 0 &&
                    <span className="label label-primary pull-right">{count}</span>
                }
            </span>

        </>
    )
}
